export const MainPageStates = Object.freeze({
  DONATIONS: "DONATIONS",
  SETTINGS: "SETTINGS",
  TOKENS: "TOKENS",
  ARCHIVE: "ARCHIVE",
});
 